import { $axios } from "lib/axios";

export const postUploadFile = async <T>({ formData }: { formData: FormData }) => {
  const res = await $axios.post<T>("/file", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "*/*",
    },
  });

  return res.data;
};
